import { Alert, Box, Typography } from '@mui/material';

import { useAppointmentSelectionStore } from '@src/store';
interface PreselectedAppointmentDateAlertProps {
	preselectedAppointmentDate: string | null;
	preselectedAppointmentTime: string | null;
}

const PreselectedAppointmentDateAlert = ({
	preselectedAppointmentDate,
	preselectedAppointmentTime,
}: PreselectedAppointmentDateAlertProps) => {
	const { fromPAO } = useAppointmentSelectionStore((store) => store);
	if (!preselectedAppointmentDate) return null;

	const formatTime = (time: string | null) => {
		if (!time) return null;
		return time.replace(/(?<! )([ap]m)/i, ' $1');
	};
	const prefixText = fromPAO ? "You're scheduling for" : 'Select a pet to continue scheduling for';

	return (
		<Alert
			variant="flatPrimary"
			severity="info"
			data-test-id="mui-alert"
			icon={false}
			sx={{
				marginTop: 2,
				marginBottom: 1,
			}}
		>
			<Typography>
				{prefixText}{' '}
				<Box component="span" fontWeight="bold">
					{preselectedAppointmentDate}
				</Box>{' '}
				at{' '}
				<Box component="span" fontWeight="bold">
					{formatTime(preselectedAppointmentTime)?.toUpperCase()}
				</Box>
			</Typography>
		</Alert>
	);
};

export default PreselectedAppointmentDateAlert;
